import apiClient from '../apiClient';
import { POST_CITY_GROUP_URL } from '../apiUrl';

const postCityGroupApi = data => {
  return apiClient.post(POST_CITY_GROUP_URL, data);
};

export default postCityGroupApi;
